module.exports = __webpack_public_path__ + "img/46.56c638a5.png";